/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button, DialogActions } from "@mui/material";
import { LinkContext } from "cms/links/link-selector/context";
import { Logger } from "cms/utils/log/logger";

const LinkDialogBottomActions = () => {
    
    const { t } = useTranslation();
    
    const {
        handleClose,
        // setOpenEdit,
        selectedLink,
        onSelectLink,
        onSaveLink,
        MODES,
        mode,
        setMode,
    } = useContext(LinkContext);

    const cancelDisabled = false;
    const saveDisabled = false;

    const handleCancel = () => {
        setMode(MODES.SELECT);
        handleClose();
    };
    // const handleClear = () => {}
    const handleSelect = () => {
        Logger.debug(selectedLink);
        if (selectedLink?.text && selectedLink?.url) {
            onSelectLink(selectedLink);
        } else {
            // FIXME: Select None?
            // onSelectLink(selectedLink)
        }
    };

    const handleSave = () => {
        if (selectedLink.text && selectedLink.url) {
            onSaveLink(selectedLink);
        } else {
            // setOpenEdit(true)
            handleClose();
        }
    };

    return (
        <DialogActions className='simplicity-link-selector-window-footer'>
            <Button variant='outlined' color='secondary' onClick={handleCancel} disabled={cancelDisabled}>
                {t("commons.cancel")}
            </Button>
            {mode === MODES.SELECT &&
                <Button variant='contained' color='primary' onClick={handleSelect}>
                    {t("commons.select")}
                </Button>
            }
            {mode === MODES.SELECT_PREVIEW &&
                <Button variant='contained' color='primary' onClick={handleSelect}>
                    {t("commons.select")}
                </Button>
            }
            {mode === MODES.EDIT &&
                <Button variant='contained' color='primary' onClick={handleSave} disabled={saveDisabled}>
                    {t("commons.save")}
                </Button>
            }
            {/*{mode === MODES.UPLOAD ? (*/}
            {/*    <>*/}
            {/*        <Button variant='outlined' color='secondary' onClick={handleClear}>*/}
            {/*            {t('commons.clear')}*/}
            {/*        </Button>*/}
            {/*        <Button variant='contained' color='primary' onClick={handleUpload}>*/}
            {/*            /!*{t('commons.select')}*!/*/}
            {/*            {t('commons.upload')}*/}
            {/*        </Button>*/}
            {/*    </>*/}
            {/*) : null}*/}
        </DialogActions>
    );
};

export { LinkDialogBottomActions };
